import { liveUpdateAttrs } from 'libs/contentful/utils';
import { CopyJustification } from 'types/constants';
import { cn } from 'utils/styles';
import ChimeKitIcon from 'components/shared/LinkWithIcon/ChimeKitIcon';
import { MediaAsset } from '@/libs/contentful/props';
import Media from '@/components/shared/Media/Media';

/**
 * Props for the CalloutGridCardIcon component
 */
interface CalloutGridCardIconProps {
  sys?: { id: string };
  icon?: string;
  copyJustification?: CopyJustification;
  image?: MediaAsset;
}

/**
 * Renders an icon for a CalloutGrid card
 * Uses ChimeKit icons and handles responsive sizing
 */
const CalloutGridCardIcon = ({ sys, icon, image, copyJustification }: CalloutGridCardIconProps) => {
  const iconWrapperClasses = cn(
    'flex-shrink-0 w-12 h-12 sm:w-18 sm:h-18 sm:mt-5',
    copyJustification === CopyJustification.Center ? 'sm:mx-auto' : '',
  );

  if (!icon && !image) return null;

  return (
    <div className={iconWrapperClasses} {...liveUpdateAttrs(sys?.id, 'icon')}>
      {icon && !image && <ChimeKitIcon iconName={icon} className="w-full h-full object-contain callout-icon" />}
      {image && <Media media={image} priority />}
    </div>
  );
};

export default CalloutGridCardIcon;
